module.exports = __webpack_public_path__ + "assets/img/36_497.58d687bc.jpg";